"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Night = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Night = function Night(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4.567l1.838 1.118-.488-2.107L11 2.168 8.832 1.98 8 0l-.848 1.98L5 2.168l1.635 1.41-.51 2.107L8 4.568zm6.568 8.001A8 8 0 013.431 1.432a8 8 0 1011.137 11.136zm.657-4.778L14 7.045l-1.25.745.34-1.405-1.09-.94 1.435-.125L14 4l.555 1.32L16 5.445l-1.1.94.325 1.405zM6.5 10.284l.919.558-.244-1.053L8 9.084 6.916 8.99 6.5 8l-.424.99L5 9.084l.817.705-.255 1.053.938-.558zm5.919 1.558l-.919-.558-.938.558.256-1.053-.818-.705 1.076-.094L11.5 9l.416.99 1.084.094-.825.705.244 1.053z",
    fill: "currentColor"
  }));
};

exports.Night = Night;
var _default = Night;
exports.default = _default;